import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = loading, false = logged out
  const [ready, setReady] = useState(false);

  useEffect(() => {
    // Session is carried by an httpOnly cookie; ask the backend who we are.
    (async () => {
      try {
        const { data } = await api.get("/auth/me");
        setUser(data.user);
      } catch (err) {
        console.debug("No active session:", err?.response?.status || err?.message);
        setUser(false);
      }
      setReady(true);
    })();
  }, []);

  const value = useMemo(() => {
    const login = async (email, password) => {
      const { data } = await api.post("/auth/login", { email, password });
      setUser(data.user);
      return data.user;
    };
    const register = async (email, password) => {
      const { data } = await api.post("/auth/register", { email, password });
      setUser(data.user);
      return data.user;
    };
    const logout = async () => {
      try { await api.post("/auth/logout"); }
      catch (err) { console.debug("Logout request failed:", err?.message); }
      setUser(false);
    };
    const updateUser = (u) => setUser(u);
    return { user, ready, login, register, logout, updateUser };
  }, [user, ready]);

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}
